module.exports = __webpack_public_path__ + "icon_music.png?fb7d706f7bf37de3ad02641d9ad2c6d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_music.png
// module id = 65
// module chunks = 0